import { getSrc } from '@sparklayer-io/spark-dash-ui/assets/utils';
import _adminB2bOnly from './images/admin-b2b-only.png';
import _adminHideShow from './images/admin-hide-show.png';
import _adminMinQty from './images/admin-min-qty.png';
import _adminMulticurrency from './images/admin-multicurrency.png';
import _adminOrderButtons from './images/admin-order-buttons.png';
import _adminPreOrder from './images/admin-pre-order.png';
import _adminPriceList1 from './images/admin-price-list1.png';
import _adminPriceList2 from './images/admin-price-list2.png';
import _adminRegistration from './images/admin-registration.png';
import _adminScriptPdpAllVariants from './images/admin-script-pdp-all-variants.png';
import _adminScriptPdpMatrix from './images/admin-script-pdp-matrix.png';
import _adminScriptQuickBuy from './images/admin-script-quickbuy.png';
import _adminShipping from './images/admin-shipping.png';

export const adminB2bOnlyGraphic = getSrc(_adminB2bOnly);
export const adminHideShowGraphic = getSrc(_adminHideShow);
export const adminMinQtyGraphic = getSrc(_adminMinQty);
export const adminMulticurrencyGraphic = getSrc(_adminMulticurrency);
export const adminOrderButtonsGraphic = getSrc(_adminOrderButtons);
export const adminPreOrderGraphic = getSrc(_adminPreOrder);
export const adminPriceList1Graphic = getSrc(_adminPriceList1);
export const adminPriceList2Graphic = getSrc(_adminPriceList2);
export const adminRegistrationGraphic = getSrc(_adminRegistration);
export const adminScriptPdpAllVariantsGraphic = getSrc(_adminScriptPdpAllVariants);
export const adminScriptPdpMatrixGraphic = getSrc(_adminScriptPdpMatrix);
export const adminScriptQuickBuyGraphic = getSrc(_adminScriptQuickBuy);
export const adminShippingGraphic = getSrc(_adminShipping);

// Hosted on sparklayer.io, no local asset needed.
export const adminScriptPdpUrl =
  'https://www.sparklayer.io/assets/images/admin/admin-script-pdp.png';
export const adminScriptPlpUrl =
  'https://www.sparklayer.io/assets/images/admin/admin-script-plp.png';
export const adminScriptPdpNoPriceUrl =
  'https://www.sparklayer.io/assets/images/admin/admin-script-pdp-no-price.png';
